import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-error-page',
  template: '<div></div>'
})
export class BlankErrorPageComponent {

}
